export const PRIVACY_ACK_VERSION = "v1";

export function getPrivacyAckStorageKey({ userType, userId }) {
  const safeUserType = String(userType || "unknown").toLowerCase();
  const safeUserId = String(userId || "unknown");
  return `privacy_ack_${PRIVACY_ACK_VERSION}_${safeUserType}_${safeUserId}`;
}

export function hasPrivacyAcknowledged({ userType, userId }) {
  try {
    const key = getPrivacyAckStorageKey({ userType, userId });
    return localStorage.getItem(key) === "true";
  } catch {
    return false;
  }
}

export function setPrivacyAcknowledged({ userType, userId }) {
  const key = getPrivacyAckStorageKey({ userType, userId });
  localStorage.setItem(key, "true");
}

